import {ConfigService, ErrorsService, TrailerIntervention, ModelsList, StoreService, TrailerInterventionAlert} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {GroupedModelsList} from '../../../../shared/src/lib/store/store.service';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class TrailerInterventionService extends StoreService<TrailerIntervention> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(TrailerIntervention);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<TrailerIntervention>> {
    return this.http.get<ModelsList<TrailerIntervention>>(this.config.apiVerUrl('/app/trailer-interventions'), {params: queryParams});
  }

  protected insert(values: TrailerIntervention): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/trailer-interventions'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/trailer-interventions/${id}`));
  }

  protected update(id, values: TrailerIntervention): Observable<TrailerIntervention> {
    return this.http.put<TrailerIntervention>(this.config.apiVerUrl(`/app/trailer-interventions/${id}`), values);
  }

  alerts(id: number): Observable<ModelsList<TrailerInterventionAlert>> {
    return this.http.get<ModelsList<TrailerInterventionAlert>>(this.config.apiVerUrl(`/app/trailer-interventions/${id}/alerts`)).pipe(
      map(l => {
        l.data = (l.data as TrailerInterventionAlert[]).map(m => new TrailerInterventionAlert(m));
        return l;
      }),
    );
  }

  updateDataAccuracyRating(id: number, rating: string): Observable<any> {
    return this.http.patch<any>(this.config.apiVerUrl(`/app/trailer-interventions/${id}/data-accuracy-rating`), {
      data_accuracy_rating: rating
    });
  }

  updateTrailer(id: number, trailerId: number): Observable<any> {
    return this.http.patch<any>(this.config.apiVerUrl(`/app/trailer-interventions/${id}/trailer`), {
      trailer_id: trailerId
    });
  }

  createManual(payload: any): Observable<any> {
    return this.http.post<any>(this.config.apiVerUrl('/app/trailer-interventions/manual'), payload);
  }

}
